var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 30.5,
    cy: 30.5,
    r: 30.5,
    fill: "#00A808"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 23.5,
    fill: "#00A808"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30058_12110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.75 32.5L28 37.75L40 25.75",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30058_12110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(19 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteStep);
export default __webpack_public_path__ + "static/media/CompleteStep.a043f588af930340de387bee1abb5620.svg";
export { ForwardRef as ReactComponent };